import styled from "@emotion/styled";
import { Tooltip } from "react-aria-components";

export const StyledTooltip = styled(Tooltip)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding-block: ${({ theme }) => theme.spacing["1"]};
  padding-inline: ${({ theme }) => theme.spacing["2"]};
  background-color: ${({ theme }) => theme.colors.surface.tooltip};
  border-radius: 6px;
  width: fit-content;
`;

export const StyledTooltipTriggerWrapper = styled.div``;
